import { CircularProgress, Dialog, DialogContent, DialogContentText, DialogProps, DialogTitle } from "@mui/material";

interface Props extends DialogProps {
  title?: string;
  message?: string;
}

export const LoadingModal: React.FC<Props> = ({ title, message, ...dialogProps }) => {
  return <Dialog {...dialogProps}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
    <DialogContent>
      <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </div>
      {message && <DialogContentText>{
        message.split('\n').map((line, index) => (
          <span key={index}>
            {line}
            <br />
          </span>
        ))
      }</DialogContentText>}
    </DialogContent>
  </Dialog>;
};